import type { SpotDto } from "@boomap/contracts";
import type { FeatureCollection, Point } from "geojson";

import { treatIconId } from "../lib/spot-offer.ts";

export interface SpotFeatureProperties {
  readonly id: string;
  /**
   * Identifiant de l'image à dessiner, calculé ici plutôt que par une
   * expression MapLibre : la correspondance se lit et s'étend mieux en
   * TypeScript qu'en `match` imbriqué.
   */
  readonly icon: string;
}

export type SpotCollection = FeatureCollection<Point, SpotFeatureProperties>;

export const toSpotCollection = (spots: readonly SpotDto[]): SpotCollection => ({
  type: "FeatureCollection",
  features: spots.map((spot) => ({
    type: "Feature",
    id: spot.id,
    geometry: { type: "Point", coordinates: [spot.longitude, spot.latitude] },
    properties: { id: spot.id, icon: treatIconId(spot.treats) },
  })),
});

export const EMPTY_COLLECTION: SpotCollection = { type: "FeatureCollection", features: [] };
